import { render } from "./NavigationCopy.vue?vue&type=template&id=8e7fb2c4"
import script from "./NavigationCopy.vue?vue&type=script&lang=js"
export * from "./NavigationCopy.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__